// extracted by mini-css-extract-plugin
export default {"rating":"Zy-z","numberOfStars":"_y-z","count":"az-z","barGraphSpacing":"bz-z","barGraph":"cz-z"};